// cupData.js

// 32개 이미지 import (engineer1 ~ engineer32)
// 실제 파일 경로에 맞춰 수정하세요!
import engineer1Img from "@/assets/img/engineer/resize/n1_Communication-Lacking Engineer.webp";
import engineer2Img from "@/assets/img/engineer/resize/n2_Jargon-Overusing Engineer.webp";
import engineer3Img from "@/assets/img/engineer/resize/n3_Art-Insensible Engineer.webp";
import engineer4Img from "@/assets/img/engineer/resize/n4_Creativity-Disregarding Engineer.webp";
import engineer5Img from "@/assets/img/engineer/resize/n5_Over-Engineering Engineer.webp";
import engineer6Img from "@/assets/img/engineer/resize/n6_Technically-Rigid Engineer.webp";
import engineer7Img from "@/assets/img/engineer/resize/n7_Siloed Engineer.webp";
import engineer8Img from "@/assets/img/engineer/resize/n8_Mutual-Understanding-Lacking Engineer.webp";
import engineer9Img from "@/assets/img/engineer/resize/n9_Function-First Engineer.webp";
import engineer10Img from "@/assets/img/engineer/resize/n10_Speed-Focused Engineer.webp";
import engineer11Img from "@/assets/img/engineer/resize/n11_By-the-Book Engineer.webp";
import engineer12Img from "@/assets/img/engineer/resize/n12_Low-Involvement Engineer.webp";
import engineer13Img from "@/assets/img/engineer/resize/n13_Irresponsible Engineer.webp";
import engineer14Img from "@/assets/img/engineer/resize/n14_Requirement-Misjudging Engineer.webp";
import engineer15Img from "@/assets/img/engineer/resize/n15_No Post-Support Engineer.webp";
import engineer16Img from "@/assets/img/engineer/resize/n16_Poor Documentation Engineer.webp";
import engineer17Img from "@/assets/img/engineer/resize/n17_Ignoring-Art-Vision Engineer.webp";
import engineer18Img from "@/assets/img/engineer/resize/n18_Aesthetic-Insensitivity Engineer.webp";
import engineer19Img from "@/assets/img/engineer/resize/n19_Collaboration-Refusing Engineer.webp";
import engineer20Img from "@/assets/img/engineer/resize/n20_Rigid-to-Change Engineer.webp";
import engineer21Img from "@/assets/img/engineer/resize/n21_Detail-Obsessed Engineer.webp";
import engineer22Img from "@/assets/img/engineer/resize/n22_Poor-Teamwork Engineer.webp";
import engineer23Img from "@/assets/img/engineer/resize/n23_Overly-Dominant Engineer.webp";
import engineer24Img from "@/assets/img/engineer/resize/n24_Under-Consulting Engineer.webp";
import engineer25Img from "@/assets/img/engineer/resize/n25_Credit-Hogging Engineer.webp";
import engineer26Img from "@/assets/img/engineer/resize/n26_Overconfident Engineer.webp";
import engineer27Img from "@/assets/img/engineer/resize/n27_Feedback-Resistant Engineer.webp";
import engineer28Img from "@/assets/img/engineer/resize/n28_Knowledge-Hoarding Engineer.webp";
import engineer29Img from "@/assets/img/engineer/resize/n29_User-Experience-Ignoring Engineer.webp";
import engineer30Img from "@/assets/img/engineer/resize/n30_Tool-Overuse Engineer.webp";
import engineer31Img from "@/assets/img/engineer/resize/n31_Inexperienced Engineer.webp";
import engineer32Img from "@/assets/img/engineer/resize/n32_Unenthusiastic Engineer.webp";

export const engineerData = [
  {
    name: "침묵 속에 코딩만!\n소통 부재형 기술자",
    img: engineer1Img,
    desc: "예술가와 충분히 대화하지 않는 기술자다. 진행 상황이나 기술적 한계를 제때 공유하지 않고, 요구사항에 대한 확인 질문도 없이 묵묵히 자기 일만 하면 예술가는 진행을 파악하지 못해 불안해지고 오해가 쌓인다. 의사소통 부족은 어떤 관계에서도 치명적이며, 용어 차이로 인한 오해까지 더해지면 장기적으로 큰 혼선을 초래한다."
  },
  {
    name: "어려운 말만 줄줄줄\n전문용어 남발형 기술자",
    img: engineer2Img,
    desc: "예술가에게 기술 jargon(전문용어)으로만 설명하여 이해를 돕지 않는 기술자다. 예술 분야 파트너는 기술 세부 내용에 익숙치 않을 수 있는데, 이를 고려하지 않고 어려운 용어를 그대로 사용하면 소통이 단절된다. 서로 다른 분야의 용어와 관행 차이를 풀어주지 않으면 오해가 커지고 협업 관계가 악화될 수 있다."
  },
  {
    name: "예술 가치 몰라도 괜찮다?\n예술 이해 부족형 기술자",
    img: engineer3Img,
    desc: "예술적 목표와 가치를 잘 이해하지 못하는 기술자다. 기능 구현에는 능하지만 작품이 전달하려는 메시지나 사용자 경험의 중요성을 간과한다. 실제 사례에서 기술자(연구자)는 시스템의 사용성 평가와 메시지 전달 여부에 관심이 많았지만, 정작 예술가들은 작품 전시에만 집중하고 관객 피드백에는 무심했다는 보고가 있다. 이는 역으로 기술자가 예술적 의도 파악에 어려움을 겪을 수 있음을 시사한다. 기술자가 예술의 관점과 사용자 경험을 충분히 고려하지 않으면 결과물이 기능적이지만 공감이나 감동을 주지 못해 실패할 수 있다."
  },
  {
    name: "“그건 불가능” 먼저 외치는\n창의성 경시형 기술자",
    img: engineer4Img,
    desc: "예술가의 창의적 아이디어를 공감하지 못하고 성급히 불가능하다고 단정짓는 기술자다. 새로운 시도를 “실현 어렵다”며 곧바로 잘라버리거나, 낯선 발상을 터무니없다고 여겨 충분히 검토하지 않으면 창의적 잠재력이 사장된다. 반면에 좋은 협업에서는 기술자도 초기부터 아이디어 발상에 참여하여 색다른 해결책을 모색하기도 한다. 이러한 참여가 없고 매사 소극적이기만 하면 예술가는 기술자를 신뢰하지 않게 되고 협업 열의가 식어버린다."
  },
  {
    name: "복잡도만 높이는\n과잉 기술집착형 기술자",
    img: engineer5Img,
    desc: "필요 이상으로 복잡한 기술 솔루션을 고집하는 기술자다. 문제를 단순히 풀 수 있음에도 최신 기술이나 본인이 선호하는 복잡한 방법으로 “오버 엔지니어링”하여 프로젝트를 그르치는 경우다. 이는 개발 기간을 늘리고 예상치 못한 버그를 양산하여 예술가는 의도한 대로 작품을 완성하지 못하게 된다. 엔지니어링 과잉으로 사용자나 예술적 가치에는 기여하지 못하는 요소를 추가하면 프로젝트 리소스만 낭비되고 실패 확률이 높아진다."
  },
  {
    name: "도구 바꿀 생각 없는\n기술 경직형 기술자",
    img: engineer6Img,
    desc: "특정 도구나 방식을 고집하여 융통성이 부족한 기술자다. 익숙한 프로그래밍 언어나 플랫폼만 쓰려 하거나, 새로운 접근법을 요구하는 예술가의 제안을 “규칙에 어긋난다”며 거부하는 태도가 이에 해당한다. 협업에서는 상황에 따라 다양한 도구와 방법을 실험할 필요가 있는데, 기술자가 한 가지 방법론에만 집착하면 창의적 해결책을 찾지 못하고 팀원과 충돌하여 협업이 실패할 수 있다."
  },
  {
    name: "소통 단절된 섬 속의\n사일로 작업형 기술자",
    img: engineer7Img,
    desc: "디자이너/예술가와 교류하지 않고 자기 업무만 따로 진행하는 기술자다. 공동 작업임에도 디자인과 개발을 철저히 분리된 사일로(silo)처럼 취급하면, 서로 피드백이 오가기 어렵고 막판에 가서야 맞지 않는 부분이 드러난다. 실제 엔지니어들도 “분리되어 따로 작업하는 방식”이 디자인-엔지니어링 협업에서 가장 문제적이라고 지적한다. 이런 방식은 통합 단계에서 큰 시행착오를 불러와 일정 지연이나 품질 저하로 이어진다."
  },
  {
    name: "예술가의 방식을 몰라 답답한\n상호 이해 부족형 기술자",
    img: engineer8Img,
    desc: "예술가의 작업 방식과 일처리 스타일을 이해하지 못하고 불만만 가지는 기술자다. 예술가는 탐색과 시안을 거치며 점진적으로 완성하는데, 엔지니어는 확정된 사양을 빨리 받아 개발하고 싶어 하므로 “디자인이 결정되지 않아 내 일이 지연된다”고 답답해할 수 있다. 반대로 예술가 입장에서는 기술자가 유연하게 기다려주지 못한다고 느낄 수 있다. 이러한 프로세스 이해 부족으로 서로를 탓하기만 하면 갈등이 깊어지고 협업이 원활히 진행되지 않는다."
  },
  {
    name: "작동만 되면 끝?\n기능 우선형 기술자",
    img: engineer9Img,
    desc: "작품의 기능 구현에만 몰두하고 사용자 경험이나 미적 완성도를 부차적으로 여기는 기술자다. 이들은 “일단 작동하면 된다”는 입장이어서, 인터페이스의 미려함이나 연출의 섬세함보다는 시스템 안정성과 성능을 중시한다. 제품 개발 맥락에서 엔지니어는 핵심 기능을 구현해 빠르게 사용자에게 제공하고 싶어하고, 디자이너는 출시 전에 충분히 다듬길 원한다는 입장 차이가 알려져 있다. 만약 기술자가 기능 구현 후 추가 개선을 등한시하면 작품이 매끄럽지 못하고 관객에게 외면받아 결국 실패할 수 있다."
  },
  {
    name: "“빨리 끝내자”에 집착하는\n속도 강박형 기술자",
    img: engineer10Img,
    desc: "최대한 빨리 완성하는 것을 중시하여 과정상의 충분한 협의를 생략하는 기술자다. 출시나 데드라인을 맞추는 데 집중한 나머지 예술적 세부 조율이나 중간 피드백 반영을 건너뛰면, 결과물이 예술가의 의도와 다르게 나올 위험이 크다. 예술가는 공들여 개선하고 싶은 부분이 남았는데 기술자가 “일단 내고 보자”는 식으로 서두르면 최종 품질에 타격을 주어 성공하기 어려워진다."
  },
  {
    name: "요구사항 복사·붙여넣기\n모범생형 기술자",
    img: engineer11Img,
    desc: "주어진 명세만 그대로 구현하고 능동적으로 제안을 하지 않는 기술자다. 겉보기에는 문제없어 보이지만, 예술가의 요구사항이 모호하거나 결점이 있을 때도 피드백 없이 수동적으로 따르기만 하면 결과물이 빈틈을 보완하지 못하고 평범하게 나올 수 있다. 창의적 협업에서는 기술자도 문제를 함께 고민하고 아이디어를 제시하는 역할이 중요한데, 이를 포기하면 협업 시너지가 줄어들어 작품의 혁신성이 떨어진다."
  },
  {
    name: "맡은 일만 ‘툭’ 하고 빠지는\n낮은 참여도형 기술자",
    img: engineer12Img,
    desc: "필요 최소한의 기술적 구현만 하고 협업에 깊이 관여하지 않는 기술자다. 예술가와 지속적으로 아이디어를 주고받거나 작품의 의미를 이해하려는 노력 없이, 자기 맡은 부분의 코딩만 완료하면 끝이라는 태도를 보인다. 이런 경우 작품이 각 부분이 따로 노는 기계적 결과물이 될 수 있다. 기술적 완성도는 있을지 몰라도 예술적 통합이 부족해 관객에게 외면받으면 협업의 목표를 이루지 못하게 된다."
  },
  {
    name: "마감지연 유발자\n낮은 책임 의식형 기술자",
    img: engineer13Img,
    desc: "프로젝트 관리나 일정 준수에 허술한 기술자다. 마감 기한을 지키지 못하거나 진척 상황을 제때 보고하지 않아 전체 일정을 어긋나게 만든다. 혹은 중요한 기술적 이슈(예: 성능 문제)를 미리 해결하지 않고 넘겨둬 막판에 위기를 초래하기도 한다. 이러한 프로젝트 관리 미흡은 협업 프로젝트의 실패 요인으로 지목되며, 기술자의 역할에 빈틈이 생기면 다른 팀원의 노력도 물거품이 될 수 있다."
  },
  {
    name: "“쉽죠!” 했다가 낭패\n요구사항 오판형 기술자",
    img: engineer14Img,
    desc: "기술 난이도나 작업량을 잘못 추정하여 계획에 차질을 주는 기술자다. 구현이 간단할 거라고 장담했지만 실제로는 복잡해서 일정이 대폭 늦어지거나, 반대로 어려운 부분을 간과해 나중에 기능을 포기해야 되는 상황을 초래한다. 이러한 오판은 위험 관리 실패와 연결되며, 초기에 잘못된 낙관으로 추진된 프로젝트는 중반 이후 급격히 어려움이 드러나 실패할 가능성이 높다."
  },
  {
    name: "전시 후엔 난 몰라요\n협업 후속지원 태만형 기술자",
    img: engineer15Img,
    desc: "작품 완성 후 유지보수나 운영 지원을 등한시하는 기술자다. 전시 혹은 공연 기간 동안 기술 시스템이 안정적으로 돌아가도록 모니터링하고 이슈를 대응해야 하는데, 이를 소홀히 하면 작품이 중단되거나 고장 나 관객에게 선보이지 못하게 된다. 실제 1960~70년대의 예술-기술 협업 사례를 보면, 전시 기간 동안의 기술 지원 부족과 작품 유지보수 실패가 문제로 지적되었다. 기술자가 끝까지 책임지고 지원하지 않으면 애써 만든 작품도 현장에서 실패로 돌아갈 수 있다."
  },
  {
    name: "코드만 있고 설명은 없다\n문서화 미흡형 기술자",
    img: engineer16Img,
    desc: "시스템 설계나 코드에 대한 문서화를 제대로 하지 않아 협업자들이 이해하거나 향후 수정하기 어렵게 만드는 기술자다. 예술가나 다른 팀원이 기술 구현 내용을 알아야 작품 연출을 조정하거나 유지보수를 계획할 수 있는데, 문서나 설명이 없으면 기술 부분이 ‘블랙박스’가 되어버린다. 이는 협업 의존성을 높이고, 기술자가 빠져나가면 아무도 고치지 못하는 위험을 낳아 프로젝트 지속에 악영향을 준다."
  },
  {
    name: "예술가 비전은 뒷전\n예술 비전 무시형 기술자",
    img: engineer17Img,
    desc: "예술가의 창작 비전을 깊이 고려하지 않고 기술 구현을 독자적으로 진행하는 기술자다. 이런 경우 결과물이 요구사항대로 동작은 해도 예술가가 의도한 분위기나 메시지 전달을 충족하지 못할 수 있다. 예술적 비전을 기술적으로 풀어내려면 긴밀한 해석과 상의가 필요한데, 기술자가 이를 무시하면 겉도는 구현이 되어 버린다. 결국 작품은 기술과 예술이 따로 놀게 되어 완성도와 호평을 기대하기 어렵다."
  },
  {
    name: "감각 제로, 기본 스킨 고수\n미학적 감수성 부족형 기술자",
    img: engineer18Img,
    desc: "시각·청각적 디자인에 관심이나 감각이 부족한 기술자다. 인터랙티브 아트나 게임 개발에서, 기능은 정상이지만 미적 완성도가 떨어지는 결과물이 나오면 사용자에게 외면당한다. 기술자가 아트 디렉션을 이해하지 못한 채 기본 폰트, 기본 UI만으로 구현하거나, 조도·음향 등 환경 요소를 간과하면 작품의 예술성이 훼손된다. 이러한 미학적 감수성 결여는 협업 결과를 ‘공학적 프로토타입’ 수준에 머물게 해 예술적 성취를 가로막는다."
  },
  {
    name: "아이디어 교류 자체를 거부하는\n협업 거부형 기술자",
    img: engineer19Img,
    desc: "예술가와의 아이디어 교류를 꺼리고 자신이 맡은 부분 외에는 관여하지 않으려는 기술자다. 이는 예술가의 의견을 들을 기회도, 자신의 기술적 제안을 제시할 기회도 스스로 닫아버리는 셈이다. 팀내 원활한 협업을 위해서는 서로의 영역에도 관심을 가지고 참여해야 하는데, 이 유형의 기술자는 철저히 분업만 추구하여 결과적으로 융합적 창작을 이뤄내지 못하고 실패로 이어질 수 있다."
  },
  {
    name: "계획 수정이 불편한\n변화 대응 경직형 기술자",
    img: engineer20Img,
    desc: "프로젝트 요구사항이나 디자인 변경에 유연하게 대응하지 못하는 기술자다. 창의적 프로젝트에서는 초기 계획이 새롭게 조정될 수 있는데, 기술자가 처음에 짜둔 구조나 일정만 고집하며 변경을 수용하지 않으면 팀 내 갈등이 커진다. 민첩한 대응 대신 “이미 코드가 이렇게 되어 있어서 안 된다”는 식으로 나오면, 협업의 창의적 발전이 가로막혀 결과적으로 완성도가 떨어진 채 마무리될 수 있다."
  },
  {
    name: "큰 그림 외면하고 디테일에 빠진\n세부 몰입형 기술자",
    img: engineer21Img,
    desc: "전체 그림보다는 눈앞의 기술적 세부에만 집착하는 기술자다. 부분 최적화에 몰두한 나머지 작품의 전체 콘셉트나 사용자 경험 맥락을 놓치는 경우가 해당된다. 예를 들어 한 연구자는 1cm 정밀도의 위치 추적 오류에 신경을 썼지만 예술가들은 이를 사소하게 여기고 오히려 공연 중 시스템 안정성을 더 중시했다고 한다. 이처럼 기술자가 매달린 세부 요소가 작품의 큰 의도와 무관하면 노력 대비 효과가 적고, 프로젝트 자원을 잘못 투자하여 실패 위험을 높인다."
  },
  {
    name: "충돌만 남기고 고립되는\n팀워크 미흡형 기술자",
    img: engineer22Img,
    desc: "협업 팀 내 원만한 관계 형성에 실패하여 고립되는 기술자다. 원만한 협업을 위해서는 서로 신뢰와 존중이 바탕이 되어야 하는데, 기술자가 커뮤니케이션 능력이 부족하거나 예술가와 계속 충돌하여 팀워크를 형성하지 못하면 효과적인 공동작업이 불가능해진다. 팀 내 고립된 기술자는 정보와 맥락을 놓치게 되고, 이는 곧 전체 프로젝트의 실패로 이어질 수 있다."
  },
  {
    name: "“내가 기술적 권위자다!”\n주도권 과잉형 기술자",
    img: engineer23Img,
    desc: "기술적 권위를 앞세워 협업의 주도권을 과도하게 장악하려는 기술자다. 예술가의 의견이나 요구보다 자신의 기술적 판단을 우위에 두고 프로젝트 방향을 좌지우지하려 하면 창의적 균형이 깨진다. 예를 들어 기술자가 “이건 기술적으로 불가능하니 다른 방향으로 한다”고 쉽게 단정지어 버리면 예술가는 자신의 비전이 묵살당했다고 느낄 수 있다. 이러한 권위적 태도는 창의적 파트너십을 저해하여 협업 성공을 어렵게 만든다."
  },
  {
    name: "합의 없이 기술 독단!\n과소협의형 기술자",
    img: engineer24Img,
    desc: "중요한 구현사항을 예술가와 충분히 상의하지 않고 독단적으로 결정하는 기술자다. 인터랙티브 요소의 구현 방식이나 사용자 인터페이스처럼 작품 인상에 영향을 줄 수 있는 부분을 기술자가 임의로 처리하면, 나중에 예술가가 불만을 제기해 수정하느라 시간과 자원을 소모하게 된다. 사전에 크고 작은 결정들을 예술가와 협의하는 과정이 없다면 최종 산출물이 일관성을 잃고 협업 효율도 떨어져 실패로 이어질 가능성이 높다."
  },
  {
    name: "공로는 전부 내 것!\n성과 독점형 기술자",
    img: engineer25Img,
    desc: "협업 결과에 대한 성과를 자신 위주로 인정받고자 하는 기술자다. 예술-기술 협업에서 드물긴 하지만, 기술자가 해당 작품의 핵심을 자신의 기술이라고 주장하며 예술가의 기여를 평가절하하면 심각한 갈등이 생긴다. 또는 산출물의 소유권을 두고 법적 분쟁까지 가는 사례도 있다. 이종 분야 협업의 IP 문제는 항상 잠재적 위험 요인이며, 기술자가 예술가의 창의적 공헌을 존중하지 않고 성과를 독차지하려 들면 협업 관계는 파국을 맞게 된다."
  },
  {
    name: "“문제없어요” 자신만만 후 폭풍\n과신형 기술자",
    img: engineer26Img,
    desc: "자신의 기술적 능력을 과신하여 무리한 계획을 추진하거나 타인의 도움을 무시하는 기술자다. “문제없다”며 방심하고 충분한 검증 없이 구현을 진행하다 예기치 않은 장애에 부딪히거나, 초기 약속한 성능을 끝내 달성하지 못해 프로젝트를 위험에 빠뜨린다. 또한 동료나 예술가가 제시하는 우려를 가볍게 여기다 큰 문제를 키우기도 한다. 이런 오만한 태도는 협업에서 치명적 실패를 부르기 쉽다."
  },
  {
    name: "개선 제안은 거절!\n피드백 불수용형 기술자",
    img: engineer27Img,
    desc: "예술가나 사용자로부터의 피드백을 잘 받아들이지 않는 기술자다. 구현 중간에 예술가가 수정 요청이나 방향 제안을 해도 기술자가 방어적으로 굴거나 무시해버리면, 최종 결과물이 예술가의 기대와 동떨어지게 된다. 사용성 테스트나 시연에서 나온 개선점에 귀 기울이지 않는 것도 마찬가지다. 피드백을 수렴하여 반복 개선(iteration)하는 과정이 부족하면 작품의 완성도가 떨어지고 협업의 성공을 담보하기 어렵다."
  },
  {
    name: "“내가 다 알고 있어!”\n지식 독점형 기술자",
    img: engineer28Img,
    desc: "프로젝트 관련 기술 지식을 혼자만 알고 공유하지 않는 기술자다. 예술가나 다른 팀원에게 시스템 작동 원리나 제약 조건 등을 충분히 설명하지 않으면, 의사결정에 필요한 정보가 한쪽에만 치우치게 된다. 이는 예술가가 현실적인 기대치를 가질 기회를 박탈하고, 문제 발생 시 협업으로 해결하기보다 기술자 한 명에게 과도한 부담이 집중되게 만들어 프로젝트 리스크를 높인다. 지식 공유 부재는 팀원들의 협업 기여도를 제한하여 최종 성과를 저해한다."
  },
  {
    name: "관객 배려 전혀 없는\n사용자 경험 무시형 기술자",
    img: engineer29Img,
    desc: "최종 사용자의 경험이나 상호작용을 고려하지 않고 기술 구현을 완료하는 기술자다. 시스템이 돌아가기만 하면 역할을 다했다고 생각해 인터페이스의 직관성, 설치 현장의 사용자 동선, 작품과 상호작용하는 관객의 감정선을 간과한다. 그 결과 사용자에게 불친절하거나 몰입감을 주지 못하는 작품이 되어버리고, 관객의 외면으로 이어질 수 있다. 이는 기술자가 예술 작품에서 관객의 역할을 경시한 결과로, 결국 작품의 사회적 성공을 가로막는다."
  },
  {
    name: "맞지도 않는 툴을 억지로 적용!\n도구 남용형 기술자",
    img: engineer30Img,
    desc: "프로젝트에 맞지 않는 도구나 기술을 고집하여 문제를 야기하는 기술자다. 가장 적합한 방법보다 자신이 선호하거나 익숙한 프레임워크, 라이브러리를 사용하려 하고, 때로는 유행하는 신기술을 굳이 적용하려다가 예상치 못한 오류나 호환성 문제를 만드는 경우다. 기술 선택은 예술적 목표에 부합해야 하지만, 기술자가 이를 무시하면 구현 실패나 성능 저하로 작품이 의도대로 구현되지 못한다."
  },
  {
    name: "예술 세계 적응 실패\n경험 부족형 기술자",
    img: engineer31Img,
    desc: "예술 분야 협업 경험이 부족하여 시행착오를 겪는 기술자다. 주로 전통 산업/공학 분야 출신 개발자가 처음 미디어아트나 게임 아트 프로젝트에 참여할 때 이런 일이 생긴다. 창의적 작업 특유의 유동성과 감성적 요구사항에 적응하지 못해 처음에는 무엇이 중요하고 덜 중요한지 판단하기 어려워 하며, 협업 방법론도 익숙지 않아 헤매기 쉽다. 숙련된 동료의 도움 없이 이러한 학습 곡선을 극복하지 못하면 프로젝트 진행에 차질이 생기고 품질 저하나 일정 실패로 이어질 수 있다."
  },
  {
    name: "열의 없는 코딩 머신\n열정 부족형 기술자",
    img: engineer32Img,
    desc: "예술적 프로젝트에 흥미나 열의가 낮아 최소한의 노력만 기울이는 기술자다. 이런 경우 창의적 해결책이나 품질 향상을 위한 추가 노력을 기대하기 어렵고, 결과물도 그저 그런 수준에 머물게 된다. 예술가는 자신의 작품에 열정을 쏟는데 기술 파트너가 냉담하다면 협업 관계도 금세 소원해지고 팀원간 온도 차이로 인한 갈등이 생길 수 있다. 기술자의 낮은 몰입도는 협업 프로젝트 전체의 동력을 떨어뜨려 성공 가능성을 저해한다."
  },
];
